/**
 * Deux services rendus au panier.
 *
 * 1. OUVRIR LE TIROIR APRÈS UN AJOUT fait depuis une carte, un ensemble ou une
 *    fiche produit. Horizon ne l'ouvre pas de lui-même sur un ajout rapide : il
 *    se contente de cocher le bouton. La maquette montre le tiroir ouvert avec
 *    les suggestions juste après l'ajout — c'est là que se joue le panier
 *    moyen, et c'est aussi la seule confirmation lisible que l'article est
 *    bien entré. On n'intercepte pas l'ajout : on observe la pastille de
 *    quantité que le thème met à jour. Si l'ajout échoue, elle ne bouge pas et
 *    le tiroir ne s'ouvre pas.
 *
 * 2. RÉÉCRIRE LES MONTANTS du panier à la française. Le format monétaire de la
 *    boutique rend « €99,90 ». Les fiches et les cartes passent par cv-prix et
 *    sont déjà correctes ; le panier, lui, vient de deux gros fichiers du
 *    thème qu'on ne réécrit pas pour un symbole. On corrige donc à
 *    l'affichage, sur les seuls nœuds de texte du tiroir et de la page panier.
 *
 *    ⚠ Ce correctif est un pansement, pas la solution. Le vrai réglage est dans
 *    l'admin : Paramètres > Informations sur la boutique > Formatage des
 *    devises, à passer en « {{amount_with_comma_separator}} € ». Lui seul vaut
 *    aussi pour le passage en caisse et les e-mails de confirmation, que le
 *    thème ne touche pas. Une fois fait, ce code ne trouve plus rien à
 *    corriger et devient inerte de lui-même : il ne double jamais le symbole.
 */

(function () {
  /* ----------------------------------------------------------------------
     1. Ouverture du tiroir
     ---------------------------------------------------------------------- */

  var SELECTEURS = [
    '.cv-carte__quick button[name="add"]',
    '.cv-ens__form button[name="add"]',
    '.cv-achat button[name="add"]',
  ].join(', ');

  var attente = null;

  function pastille() {
    return document.querySelector('.cart-bubble');
  }

  function ouvrir() {
    var tiroir = document.getElementById('cart-drawer');
    if (tiroir && typeof tiroir.open === 'function') tiroir.open();
  }

  document.addEventListener('click', function (e) {
    var bouton = e.target instanceof Element ? e.target.closest(SELECTEURS) : null;
    if (!bouton) return;

    var p = pastille();
    if (!p) return;

    /* Une seule attente à la fois : un double clic ne doit pas armer deux
       observateurs qui ouvriraient le tiroir deux fois. */
    if (attente) {
      clearTimeout(attente.minuteur);
      attente.observateur.disconnect();
    }

    var avant = p.textContent.trim();

    var observateur = new MutationObserver(function () {
      if (p.textContent.trim() === avant) return;
      nettoyer();
      ouvrir();
    });

    observateur.observe(p, { childList: true, subtree: true, characterData: true, attributes: true });

    /* Garde-fou : au-delà de six secondes, l'ajout a échoué ou le thème a
       changé de comportement. On relâche plutôt que d'observer sans fin. */
    var minuteur = setTimeout(nettoyer, 6000);

    attente = { observateur: observateur, minuteur: minuteur };

    function nettoyer() {
      observateur.disconnect();
      clearTimeout(minuteur);
      attente = null;
    }
  });

  /* ----------------------------------------------------------------------
     2. Écriture française des montants
     ---------------------------------------------------------------------- */

  /* € suivi d'un nombre, éventuellement suivi du code ISO. Le symbole doit
     précéder : si la boutique a déjà le bon format, rien ne correspond. */
  var MONNAIE = /€\s?(\d[\d   .]*(?:,\d{2})?)(\s*EUR)?/g;

  function corrigerTexte(t) {
    return t.replace(MONNAIE, function (_tout, nombre) {
      return nombre.trim() + ' €';
    });
  }

  var enCours = false;

  function corriger(racine) {
    if (!racine || enCours) return;
    enCours = true;

    try {
      var marcheur = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          return n.nodeValue && n.nodeValue.indexOf('€') !== -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        },
      });

      var aTraiter = [];
      while (marcheur.nextNode()) aTraiter.push(marcheur.currentNode);

      aTraiter.forEach(function (n) {
        var neuf = corrigerTexte(n.nodeValue);
        if (neuf !== n.nodeValue) n.nodeValue = neuf;
      });
    } finally {
      enCours = false;
    }
  }

  function zones() {
    return [document.getElementById('cart-drawer'), document.querySelector('.cart-page, #MainContent[data-template="cart"]')].filter(
      Boolean
    );
  }

  function surveiller() {
    zones().forEach(function (zone) {
      corriger(zone);
      new MutationObserver(function (mutations) {
        if (enCours) return;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList' || mutations[i].type === 'characterData') {
            corriger(zone);
            return;
          }
        }
      }).observe(zone, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveiller);
  } else {
    surveiller();
  }
})();
